import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default1kkisaow5bg5n as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      r25(_this__u8e3s4, index) {
        return this.t25(this.s25(_this__u8e3s4, index));
      }
      t25(nestedName) {
        var tmp0_elvis_lhs = this.w25();
        return this.x25(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      s25(descriptor, index) {
        return descriptor.r1p(index);
      }
      x25(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      y25() {
        return this.u25_1.n1() ? '$' : joinToString(this.u25_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
function tagBlock($this, tag, block) {
  $this.m26(tag);
  var r = block();
  if (!$this.v25_1) {
    $this.n26();
  }
  $this.v25_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.u25_1 = ArrayList().p2();
        this.v25_1 = false;
      }
      x1r() {
        return EmptySerializersModule();
      }
      z25(tag) {
        throw SerializationException().m1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      a26(tag) {
        return true;
      }
      b26(tag) {
        var tmp = this.z25(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      c26(tag) {
        var tmp = this.z25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      d26(tag) {
        var tmp = this.z25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      e26(tag) {
        var tmp = this.z25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      f26(tag) {
        var tmp = this.z25(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      g26(tag) {
        var tmp = this.z25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      h26(tag) {
        var tmp = this.z25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      i26(tag) {
        var tmp = this.z25(tag);
        return tmp instanceof Char() ? tmp.e4_1 : THROW_CCE();
      }
      j26(tag) {
        var tmp = this.z25(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      k26(tag, enumDescriptor) {
        var tmp = this.z25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      l26(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.m26(tag);
        return this;
      }
      g1r(deserializer, previousValue) {
        return this.h1r(deserializer);
      }
      f1r(descriptor) {
        return this.l26(this.n26(), descriptor);
      }
      t1q() {
        var tmp0_elvis_lhs = this.w25();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.a26(currentTag);
      }
      u1q() {
        return null;
      }
      v1q() {
        return this.b26(this.n26());
      }
      w1q() {
        return this.c26(this.n26());
      }
      x1q() {
        return this.d26(this.n26());
      }
      y1q() {
        return this.e26(this.n26());
      }
      z1q() {
        return this.f26(this.n26());
      }
      a1r() {
        return this.g26(this.n26());
      }
      b1r() {
        return this.h26(this.n26());
      }
      c1r() {
        return this.i26(this.n26());
      }
      d1r() {
        return this.j26(this.n26());
      }
      e1r(enumDescriptor) {
        return this.k26(this.n26(), enumDescriptor);
      }
      i1r(descriptor) {
        return this;
      }
      j1r(descriptor) {
      }
      k1r(descriptor, index) {
        return this.b26(this.r25(descriptor, index));
      }
      l1r(descriptor, index) {
        return this.c26(this.r25(descriptor, index));
      }
      m1r(descriptor, index) {
        return this.d26(this.r25(descriptor, index));
      }
      n1r(descriptor, index) {
        return this.e26(this.r25(descriptor, index));
      }
      o1r(descriptor, index) {
        return this.f26(this.r25(descriptor, index));
      }
      p1r(descriptor, index) {
        return this.g26(this.r25(descriptor, index));
      }
      q1r(descriptor, index) {
        return this.h26(this.r25(descriptor, index));
      }
      r1r(descriptor, index) {
        return this.i26(this.r25(descriptor, index));
      }
      s1r(descriptor, index) {
        return this.j26(this.r25(descriptor, index));
      }
      t1r(descriptor, index) {
        return this.l26(this.r25(descriptor, index), descriptor.u1p(index));
      }
      u1r(descriptor, index, deserializer, previousValue) {
        var tmp = this.r25(descriptor, index);
        return tagBlock(this, tmp, () => this.g1r(deserializer, previousValue));
      }
      w1r(descriptor, index, deserializer, previousValue) {
        var tmp = this.r25(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.r1m().g1p();
          var tmp;
          if (isNullabilitySupported || this.t1q()) {
            tmp = this.g1r(deserializer, previousValue);
          } else {
            tmp = this.u1q();
          }
          return tmp;
        });
      }
      w25() {
        return lastOrNull(this.u25_1);
      }
      m26(name) {
        this.u25_1.i2(name);
      }
      n26() {
        var r = this.u25_1.c5(get_lastIndex(this.u25_1));
        this.v25_1 = true;
        return r;
      }
    }
    protoOf($).v1r = decodeSerializableElement$default;
    protoOf($).h1r = decodeSerializableValue;
    protoOf($).y1r = decodeSequentially;
    protoOf($).a1s = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
